import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import {Observable} from "rxjs";
import {Configuration} from "../../assets/Configuration";
import { LearningPathFullModel, LearningPathModel } from "../models/learning-paths/learning-path.model";
import { LearningPathCreationAndUpdateModel } from '../models/learning-path/learning-path-creation-and-update.model';
import { RawFileModel } from '../models/raw-file-model';
import { CoursePersonStatusModel, LearningPathCourseAddModel, LearningPathCourseModel } from '../models/learning-path/learning-path-course.model';
import { LearningPathPersonByStateModel } from '../models/person-states/learning-path-person-by-state.model';
import { FileModel } from '../models/file.model';
import { LearningPathOverviewModel } from '../models/learning-paths/learning-path-overview.model';

@Injectable({
  providedIn: 'root'
})
export class LearningPathService {

  constructor(private httpClient: HttpClient) {
  }

  public getAllLearningPathsFull(): Observable<LearningPathFullModel[]> {
    return this.httpClient.get<LearningPathFullModel[]>(
      Configuration.getApiBaseUrl() + "/learningpath/full"
    );
  }

  public getAllLearningPaths(): Observable<LearningPathModel[]> {
    return this.httpClient.get<LearningPathModel[]>(
      Configuration.getApiBaseUrl() + "/learningpath/"
    );
  }

  public getLearningPathsOverview(): Observable<LearningPathOverviewModel[]> {
    return this.httpClient.get<LearningPathOverviewModel[]>(
      Configuration.getApiBaseUrl() + '/learningpath/overview'
    );
  }


  public getLearningPathFull(id: string): Observable<LearningPathFullModel> {
    return this.httpClient.get<LearningPathFullModel>(
      Configuration.getApiBaseUrl() + "/learningpath/" + id+ "/full"
    );
  }

  public getLearningPath(id: string): Observable<LearningPathModel> {
    return this.httpClient.get<LearningPathModel>(
      Configuration.getApiBaseUrl() + "/learningpath/" + id
    );
  }


  public addLearningPath(
    model: LearningPathCreationAndUpdateModel
  ): Observable<LearningPathFullModel> {
    return this.httpClient.post<LearningPathFullModel>(
      Configuration.getApiBaseUrl() + "/learningpath/", model
    );
  }

  public updateLearningPath(
    id: string, model: LearningPathCreationAndUpdateModel
  ): Observable<LearningPathFullModel> {
    return this.httpClient.post<LearningPathFullModel>(
      Configuration.getApiBaseUrl() + "/learningpath/" + id, 
      model
    );
  }

  public addLearningPathFile(
    id: string, file: RawFileModel
  ): Observable<FileModel> {
    return this.httpClient.post<FileModel>(
      Configuration.getApiBaseUrl() + "/learningpath/" + id + "/file", 
      file
    );
  }

  public deleteLearningPathFile(
    id: string, fileId: string
  ): Observable<void> {
    return this.httpClient.delete<void>(
      Configuration.getApiBaseUrl() + "/learningpath/" + id + "/file/" + fileId
    );
  }

  public getLearningPathPersons(id: string): Observable<LearningPathPersonByStateModel> {
    return this.httpClient.get<LearningPathPersonByStateModel>(
      Configuration.getApiBaseUrl() + '/learningpath/' + id + '/persons'
    );
  }


  public getAnyCompletedPersons(id: string): Observable<boolean> {
    return this.httpClient.get<boolean>(
      Configuration.getApiBaseUrl() + '/learningpath/' + id + '/any-completed'
    );
  }

  public getLearningPathCourses(id: string): Observable<LearningPathCourseModel[]> {
    return this.httpClient.get<LearningPathCourseModel[]>(
      Configuration.getApiBaseUrl() + "/learningpath/" + id + "/courses"
    );
  }

  public getCoursePersonStatus(id: string, courseTemplateId: string): Observable<CoursePersonStatusModel> {
    const params = new HttpParams()
      .set('courseTemplateId', courseTemplateId);
    
    return this.httpClient.get<CoursePersonStatusModel>(
      Configuration.getApiBaseUrl() + "/learningpath/" + id + "/course-person-status",
      { params: params}
    );
  }


  public addLearningPathCourse(model: LearningPathCourseAddModel): Observable<void> {
    return this.httpClient.post<void>(
      Configuration.getApiBaseUrl() + "/learningpath/add-course", model
    );
  }

  public deleteLearningPathCourse(id: string): Observable<void> {
    return this.httpClient.delete<void>(
      Configuration.getApiBaseUrl() + "/learningpath/remove-course/" + id
    );
  }
}
